import { render } from "./LoanDuration.vue?vue&type=template&id=45ba2816"
import script from "./LoanDuration.vue?vue&type=script&lang=js"
export * from "./LoanDuration.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__